import { useClientDetailHeader } from './hooks';
import { ClientDetailHeaderPresentation } from './presentations';

type Props = {
  /** クライアントID */
  id: number;
};

/**
 * クライアント詳細ヘッダー Container
 *
 * - API からクライアント名を取得してパンくずリストを表示する
 * - 親コンポーネント（Screen）で Suspense にラップすること
 */
export const ClientDetailHeader: React.FC<Props> = ({ id }) => {
  const {
    state: { data },
  } = useClientDetailHeader(id);

  return <ClientDetailHeaderPresentation clientName={data.client.name} />;
};
